
const INVENTORY = "INVENTORY";
const UTILITIES = "UTILITIES";
const EMAILS = "EMAILS";
const AP_PAYMENTS = "AP_PAYMENTS";
const RENEWALS = "RENEWALS";
const ADMIN_ROUTED_CATEGORIES = [AP_PAYMENTS];
const EXCLUDED_FROM_SYSTEM_NOTIFICATIONS = [INVENTORY];
const SYSTEM_NOTIFICATION_SUB_CATEGORY_EXCEPTIONS = {
    [INVENTORY]: ['low-units', 'inbound-transit', 'warehouse-replenishment-daily'],
};
const isHiddenFromSystemNotifications = ({ category, sub_category } = {}) =>
    EXCLUDED_FROM_SYSTEM_NOTIFICATIONS.includes(category)
    && !(SYSTEM_NOTIFICATION_SUB_CATEGORY_EXCEPTIONS[category] || []).includes(sub_category ?? null);

const enumInventoryStatuses = {
    [INVENTORY]: 'Inventory',
    [UTILITIES]: 'Utilities',
    [EMAILS]: 'Emails',
    [AP_PAYMENTS]: 'AP Payments',
    [RENEWALS]: 'Renewals',
}

module.exports = {
    enumInventoryStatuses,
    INVENTORY,
    UTILITIES,
    EMAILS,
    AP_PAYMENTS,
    RENEWALS,
    ADMIN_ROUTED_CATEGORIES,
    EXCLUDED_FROM_SYSTEM_NOTIFICATIONS,
    SYSTEM_NOTIFICATION_SUB_CATEGORY_EXCEPTIONS,
    isHiddenFromSystemNotifications,
}